import React from "react"
import "../style.css"
import Appbar from "../components/appbar"
import Info from "../components/info"
// import { Helmet } from "react-helmet"
import SEO from "../components/SEO"

function index() {
  return (
    <div>
      <Appbar />
      <Info />
      <SEO title="Home | Kaustubh" />
    </div>
  )
}

export default index
